/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Full_NegotiationInputs */

const en_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full + Negotiation`)
};

const de_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig + Verhandlung`)
};

const fr_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complet + Négociation`)
};

const es_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo + Negociación`)
};

const it_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo + Negoziazione`)
};

const nl_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig + Onderhandelingen`)
};

const pl_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny + Negocjacje`)
};

const fi_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täysi + neuvottelu`)
};

const da_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuld + Forhandling`)
};

const sv_settings_full_negotiation = /** @type {(inputs: Settings_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig + Förhandling`)
};

/**
* | output |
* | --- |
* | "Full + Negotiation" |
*
* @param {Settings_Full_NegotiationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_full_negotiation = /** @type {((inputs?: Settings_Full_NegotiationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Full_NegotiationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_full_negotiation(inputs)
	if (locale === "fr") return fr_settings_full_negotiation(inputs)
	if (locale === "es") return es_settings_full_negotiation(inputs)
	if (locale === "it") return it_settings_full_negotiation(inputs)
	if (locale === "nl") return nl_settings_full_negotiation(inputs)
	if (locale === "pl") return pl_settings_full_negotiation(inputs)
	if (locale === "fi") return fi_settings_full_negotiation(inputs)
	if (locale === "da") return da_settings_full_negotiation(inputs)
	if (locale === "sv") return sv_settings_full_negotiation(inputs)
	return en_settings_full_negotiation(inputs)
});